import { StyledErrorContainer } from "./style";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";

const MyListErrorState = () => {
    return (
        <I18n
            translatable={{ key: "si.my-lists.error.state.message" }}
            element={StyledErrorContainer}
        />
    );
};

export default MyListErrorState;
